import React from "react";
import HeroSection from "../../components/HeroSection/HeroSection";
import section_image_2 from "../../assets/images/section_image_2.jpg";
import section_image_3 from "../../assets/images/section_image_3.png";
import missions from "../../assets/images/missions.jpg";
import about_us from "../../assets/images/aboutus.png";
import "./AboutUs.css";
import Heading from "../../components/Heading/Heading";
import RightImage from "../../components/RightSection/RightImage";
import LeftImage from "../../components/LeftSection/LeftImage";
import { Helmet } from "react-helmet";

export default function AboutUs() {
  return (
    <div className="aboutus_page">
      <Helmet>
        <title>About Us | Elegro Energy Limited</title>
        <link rel="canonical" href="/aboutus" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="A company, striving and specialising to fulfil in supplying and constructing the best electrical transmission and distribution networks to our customers in Africa."
        />
      </Helmet>
      <HeroSection
        heroTitle="About Elegro Energy  Limited."
        heroParagraph="A highly successful and experienced trading and construction company."
        btnLink="/projects"
        btnText="View Projects"
        heroImage={section_image_2}
      />
      <div className="container padding_top_bottom">
        <Heading MainHeader="ABOUT COMPANY" />
        <div className="row">
          <div className="about_item layout-col-lg-6 layout-col-md-6 layout-col-sm-12">
            <p>
              Elegro Energy Limited is a highly successful and experienced
              trading and construction company, specialising in the supply only
              & full EPC turnkey & construction of electrical transmission and
              distribution network systems to power utilities, contractors and
              construction companies in Africa.
            </p>
            <p>
              Currently active in Africa, our reputation as a supplier &
              contractor are well known in the electrical engineering industry.
              We place customer satisfaction first, and achieve this with great
              attention to detail by our team of marketing, logistics, technical
              and administrative staff that manage the supply chain from design
              up to final commissioning and sign off.
            </p>
            <p>
              A dedicated team for each project is tasked with maintaining the
              manufacture, factory acceptance testing and packaging of our
              products to ensure that the highest standards are consistently
              maintained. Post production, the loading and transportation of
              products and equipment is overseen by a professional logistics
              team, who carry out regular supplier quality audits and
              evaluations on shipping lines, road haulers and rail brokers to
              ensure that each consignment reaches it’s destination in time and
              in good order, anywhere in Africa. On site, our dedicated team
              keep to set milestones during construction and installation
              throughout testing and commissioning until signoff have been
              completed.
            </p>
          </div>
          <div className="about_item layout-col-lg-6 layout-col-md-6 layout-col-sm-12">
            <img src={about_us} alt="power connections" />
            <p>
              Reputable and reliable manufacturers and suppliers are always
              selected on stringent compliance criteria to ensure quality and
              suitability of products for various markets. Our manufacturers &
              subcontractors comply with internationally recognized standards
              (e.g. SANS, IEC) and are accredited with the ISO quality
              managements systems. In addition, all products are type tested by
              independent and accredited laboratories.
            </p>
          </div>
        </div>
        <RightImage
          Subtitle="Company History"
          Paragraph="The company started in the year 2012 with it’s name called Rousant. Rousant was created by a group of intelligent electrical engineers who wanted to use what they know in a trumenndous way. They started because they wanted to do something of their own. Something that involves what they love and that could keep them running for years. They started a business that involves what they love and doing what they love."
          btnLink=""
          btnText=""
          SideImage={section_image_3}
        />
        <LeftImage
          Subtitle="Our Mission"
          Paragraph="We aim to provide turnkey solutions that mirror the best international standards by combining our own expertise and leverage to ensure world class Engineering Procurement and construction of Competitive prices."
          btnLink=""
          btnText=""
          SideImage={missions}
        />
        <div className="container">
          <div className="vision">
            <h1>Vision</h1>
            <p>Making Engineering, Procurement and Construction easy.</p>
          </div>

          <div className="core-values">
            <h1>Core values</h1>
            <div className="row">
              <div className="core-value-item layout-col-lg-4 layout-col-md-6 layout-col-sm-12">
                <h2>1</h2>
                <p>Zero Corruptions.</p>
              </div>
              <div className="core-value-item layout-col-lg-4 layout-col-md-6 layout-col-sm-12">
                <h2>2</h2>
                <p>Passionate.</p>
              </div>
              <div className="core-value-item layout-col-lg-4 layout-col-md-6 layout-col-sm-12">
                <h2>3</h2>
                <p>Great work ethics.</p>
              </div>
              <div className="core-value-item layout-col-lg-4 layout-col-md-6 layout-col-sm-12">
                <h2>4</h2>
                <p>Competitive with great teamwork.</p>
              </div>
              <div className="core-value-item layout-col-lg-4 layout-col-md-6 layout-col-sm-12">
                <h2>5</h2>
                <p>Generating Valuable Solutions.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
